export default "__VITE_ASSET__EGWZf1Qx__"